import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockTextList {
    constructor() {
        this.blocks = document.querySelectorAll(".block-text-list");

        if (this.blocks && this.blocks.length > 0) {
            this.listAnim();
        }
    }

    listAnim() {
        this.blocks.forEach(block => {
            const items = block.querySelectorAll(".text-list-item");
            gsap.set(items, {
                opacity: 0,
                y: 100,
                willChange: "transform, opacity",
            });
            items.forEach(item => {
                gsap.fromTo(item, {
                    opacity: 0,
                    y: 100
                }, {
                    opacity: 1,
                    y: 0,
                    scrollTrigger: {
                        trigger: item,
                        start: "top 85%",
                        end: "top center",
                        scrub: true,
                        invalidateOnRefresh: true
                    }
                });
            });
        });
    }
}